<template>
    <div>
        <div class="input_area">
            <div class="input_width">
                <div class="text">選択範囲ヨコ幅の実寸</div>
                <div class="input_main">
                    <div class="adjust" @click="adjust(-5)"><img src="../../assets/img/minus_icon.svg" alt="minus"></div>
                    <div class="input"><input type="number" v-model="input_width" @blur="updateImage">cm</div>
                    <div class="adjust" @click="adjust(5)"><img src="../../assets/img/add_icon.svg" alt="plus"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapMutations, mapGetters, mapActions } from 'vuex'

    export default {
        name: "InputRectSize",
        computed: {
            ...mapGetters('simulator', ['editing_item']),
            input_width: {
                get() {
                    return this.$store.state.rect_width;
                },
                set(value) {
                    this.$store.commit('setRectWidth', value);
                    return value;
                }
            },
            input_height: {
                get() {
                    return this.$store.state.rect_height;
                },
                set(value) {
                    this.$store.commit('setRectHeight', value);
                    return value;
                }
            }
        },
        methods: {
            ...mapMutations(['setRectWidth', 'setRectHeight']),
            ...mapActions('simulator', ["updateItemInfo"]),
            updateImage() { this.updateItemInfo({rect_width: this.input_width}); },
            adjust(n) {
                if (10 >= this.input_width + n) return;
                this.input_width += n;
                this.updateImage();
            }
        },
        watch: {
            editing_item(item){
                if (item.rect_width) this.input_width = item.rect_width;
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../../assets/css/define";
    *{margin: 0;}

    .input_area{
        text-align: center;
        .input_width{
            display: flex;
            justify-content: center;
            flex-wrap: wrap;
            .text{
                display: flex;
                align-items: center;
                margin-right: 1rem;
            }
            .input_main{
                display: flex;
                align-items: stretch;
                justify-content: center;
                margin: 1rem 0;
            }
            .input{ margin: 0 0.5rem; }
            .adjust{
                @extend .clickable;
                display: flex;
                align-items: center;
                justify-content: center;
                background-color: #2F5597;
                color: white;
                width: 1.5rem;
                img{ width: 14px; }
            }
        }
        input[type=number]{
            height: 1.8rem;
            width: 4.5rem;
            margin: 0 0.5rem 0 0;
            font-size: 1.2rem;
            text-align: right;
        }
    }

</style>
